import { render } from "./Index.vue?vue&type=template&id=24f0015b&scoped=true"
const script = {}

import "./Index.vue?vue&type=style&index=0&id=24f0015b&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f0015b"]])

export default __exports__